// src/utils/scrollToSection.js
import { scroller } from "react-scroll";

export const scrollToSection = (section) => {
  const isMobile = window.innerWidth < 768;

  if (section === "Contact") {
    if (isMobile) {
      // On both mobile and desktop now, the Contact section is a normal flow section
      scroller.scrollTo("Contact", {
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
        offset: -20,
      });
    } else {
      // On desktop, we can now scroll directly to the Contact ID since it follows the Skills track
      scroller.scrollTo("Contact", {
        duration: 1200,
        delay: 0,
        smooth: "easeInOutQuart",
        offset: 0, // Align exactly to the top
      });
    }
    return;
  }

  scroller.scrollTo(section, {
    duration: 800,
    delay: 0,
    smooth: "easeInOutQuart",
    offset: section === "AboutUs" || section === "Skills" ? -50 : -20,
  });
};
